export default [{
  path: '/user_activity',
  name: 'user_activity',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/userActivity/index')
}]
